import { EFinancingCompany } from '@if/core/types'
import { createContext } from 'react'

export interface PreferencesStore {
  prefersDarkMode: boolean
  setDarkMode: (value: boolean) => void
  loginPreference: number
  setLoginPreference: (value: number) => void
  selectedCompany: EFinancingCompany | null
  setSelectedCompany: (company: EFinancingCompany) => void
}

export const PreferencesContext = createContext<PreferencesStore | null>(null)

// LocalStorage keys
export const PREFERS_DARK_SETTING = 'darkMode'
export const LOGIN_PREFERENCE_KEY = 'loginPreference'
export const SELECTED_COMPANY_LOCAL_STORAGE = 'selectedCompany'

// Filter preference keys consumed by useUrlFilters / useUrlFiltersAndPagination
export const BROWSE_CREDIT_APPLICATIONS_FILTERS_KEY = 'browseCreditApplications.filters'
export const BROWSE_CREDIT_APPLICATIONS_FILTERS_ENABLED_KEY = 'browseCreditApplications.filtersEnabled'
export const CREDIT_TASK_DASHBOARD_FILTERS_KEY = 'creditTaskDashboard.filters'
export const CREDIT_TASK_DASHBOARD_FILTERS_ENABLED_KEY = 'creditTaskDashboard.filtersEnabled'
